import React, { Component } from 'react';
import PropTypes from 'prop-types';
import gradient from 'tinygradient';
import Inner from './Inner';
import styles from './styles.css';

class RainbowText extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    const {
      primaryColor, secondaryColor, children,
      className,
    } = this.props;
    if (primaryColor && secondaryColor) {
      const gc = gradient(primaryColor, secondaryColor);
      const style = {
        backgroundColor: primaryColor,
        backgroundImage: gc.css('linear', 'to bottom left'),
      };
      return (
        <div className={className}>
          <Inner onMounted={this.props.onMounted}>
            <div className={styles.wrapper} style={style}>
              {children}
            </div>
          </Inner>
        </div>
      );
    }
    return children;
  }
}

RainbowText.propTypes = {
  primaryColor: PropTypes.string,
  secondaryColor: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  onMounted: PropTypes.func,
};

RainbowText.defaultProps = {
  primaryColor: null,
  secondaryColor: null,
  children: null,
  className: null,
  onMounted: () => {},
};


export default RainbowText;
